import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { getActivePropertyFilters, toDropdownItemGroup } from './search-filter-helpers';
import { useAnalyticsDispatch } from '../../../analytics/AnalyticsContext';
import { DateFilter } from '../../../components/DateFilter/DateFilter';
import { Dropdown } from '../../../components/Dropdown/Dropdown';
import { GroupedDropdown } from '../../../components/Dropdown/GroupedDropdown';
import { PlayContainer } from '../../../components/PlayContainer/PlayContainer';
import { useViewport } from '../../../providers/ViewportProvider/ViewportContext';
import { MobileSearchFilters } from '../MobileSearchFilters/MobileSearchFilters';
import { useSearchDispatch, useSearchState } from '../SearchContext';
import { SearchFilterChips } from './SearchFilterChips';
import { StyledSearchFilters } from './SearchFilters.styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const SearchFilters = () => {
  const state = useSearchState();
  const dispatch = useSearchDispatch();
  const analytics = useAnalyticsDispatch();
  const searchFilterMetas = {
    searchTerm: state.query.searchTerm,
    mediaType: state.query.mediaType ?? 'all'
  };
  const {
    t
  } = useTranslation();
  const {
    isSmall
  } = useViewport();
  const loadAggregations = () => {
    if (!state.query.includeAggregations) {
      dispatch({
        type: 'include-aggregations'
      });
    }
  };
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [isSmall ? /*#__PURE__*/_jsx(MobileSearchFilters, {
      isOpen: state.mobileFiltersOpen,
      query: state.query,
      mediaResult: state.mediaResult,
      isLoading: state.mediaLoading,
      dates: state.dates
    }) : /*#__PURE__*/_jsx(PlayContainer, {
      width: "small",
      children: /*#__PURE__*/_jsxs(StyledSearchFilters, {
        onMouseOver: loadAggregations,
        onFocus: loadAggregations,
        children: [/*#__PURE__*/_jsx(Dropdown, {
          title: t('global.shows'),
          items: state.mediaResult?.aggregations?.shows ?? [],
          selectedItemIds: state.query.shows ?? [],
          onChange: shows => {
            dispatch({
              type: 'set-show-filter',
              shows
            });
            analytics({
              type: 'change-search-show-filter',
              ...searchFilterMetas
            });
          },
          isLoading: state.mediaLoading
        }), /*#__PURE__*/_jsx(Dropdown, {
          title: t('global.topics'),
          items: state.mediaResult?.aggregations?.topics ?? [],
          selectedItemIds: state.query.topics ?? [],
          onChange: topics => {
            dispatch({
              type: 'set-topic-filter',
              topics
            });
            analytics({
              type: 'change-search-topic-filter',
              ...searchFilterMetas
            });
          },
          isLoading: state.mediaLoading
        }), /*#__PURE__*/_jsx(GroupedDropdown, {
          title: t('search.propertyFilter'),
          groups: toDropdownItemGroup(state.mediaResult, state.query, t, ['mediaType']),
          isLoading: state.mediaLoading,
          onChange: newFilters => {
            const filters = getActivePropertyFilters(newFilters);
            dispatch({
              type: 'set-media-property-filters',
              filters
            });
            Object.values(filters).flat().forEach(property => {
              analytics({
                type: 'change-search-property-filter',
                property,
                ...searchFilterMetas
              });
            });
          }
        }), /*#__PURE__*/_jsx(DateFilter, {
          title: t('search.dateRangeFilter'),
          isLoading: state.mediaLoading,
          dates: state.dates,
          selection: {
            from: state.query.from,
            to: state.query.to
          },
          quickFilters: state.dateQuickFilters,
          oldestResultDate: state.oldestResultDate,
          markedDates: state.markedDates,
          onChange: dateRange => {
            dispatch({
              type: 'set-date-filter',
              dateRange
            });
            analytics({
              type: 'change-search-date-filter',
              ...searchFilterMetas
            });
          }
        })]
      })
    }), /*#__PURE__*/_jsx(SearchFilterChips, {})]
  });
};